import React from "react";
import { useNavigate } from "react-router-dom";
import fallBackImage from '../Assests/images/placeholderimage.jpg'

const users = [
  {
    name: "Sarah Johnson",
    role: "Educator",
    status: "Active",
    avatar: "https://randomuser.me/api/portraits/women/1.jpg",
  },
  {
    name: "Mike Chen",
    role: "Admin",
    status: "Active",
    avatar: "https://randomuser.me/api/portraits/men/2.jpg",
  },
  {
    name: "Sarah Johnson",
    role: "Educator",
    status: "Active",
    avatar: "https://randomuser.me/api/portraits/men/3.jpg",
  },
  {
    name: "Sarah Johnson",
    role: "Admin",
    status: "Active",
    avatar: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    name: "Emma Davis",
    role: "Family",
    status: "Inactive",
    avatar: "https://randomuser.me/api/portraits/women/5.jpg",
  },
  {
    name: "Emma Davis",
    role: "Family",
    status: "Inactive",
    avatar: "https://randomuser.me/api/portraits/women/6.jpg",
  },
  {
    name: "Emma Davis",
    role: "Family",
    status: "Inactive",
    avatar: "https://randomuser.me/api/portraits/men/7.jpg",
  },
  {
    name: "Emma Davis",
    role: "Family",
    status: "Inactive",
    avatar: "https://randomuser.me/api/portraits/women/8.jpg",
  },
];

const RecentUsers = ({ data, loader }) => {

  const navigate = useNavigate();

  return (
    <div className="bg-white shadow-md rounded-2xl p-5">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-gray-500">Recent Users</h2>
        <button onClick={() => navigate("/management/users")} className="text-primary-600 font-semibold text-md hover:underline">
          Manage User
        </button>
      </div>

      {/* Users List */}
      <div className="space-y-3  h-[350px] overflow-y-auto pr-2 scrollbar-hide">
        {loader ?
          <div className="h-[350px] flex items-center justify-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
          </div>
          :
          (data && data.length > 0) ? data.map((user, idx) => (
            <div
              key={idx}
              className="flex justify-between items-center p-2 rounded-lg hover:bg-gray-50"
            >
              {/* Left: Avatar + Name */}
              <div className="flex items-center space-x-3">
                <img
                  src={user?.profile_pic || fallBackImage}
                  alt={user?.full_name}
                  className="w-10 h-10 rounded-full object-cover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = fallBackImage;
                  }}
                />
                <div>
                  <p className="text-gray-800 text-[18px] font-medium">{user?.full_name}</p>
                  <p className="text-gray-500 text-[15px]">{user?.role_name}</p>
                </div>
              </div>

              {/* Status */}
              <span
                className={`px-8 py-2 rounded-lg text-sm font-medium ${user?.is_active == "1"
                  ? "bg-green-100 text-green-600"
                  : "bg-gray-200 text-gray-600"
                  }`}
              >
                {user?.is_active == '1' ? 'Active' : 'Inactive'}
              </span>
            </div>
          )) :
            <div className="text-center h-[350px] content-center">
              <p className="text-gray-400 text-sl">There are currently no users.</p>
            </div>
        }
      </div>
    </div>
  );
};

export default RecentUsers;
